import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./app/App";
import { store } from "./app/store";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { AliveScope } from 'react-activation'
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router basename="/">
        <AliveScope>
        <App />
        </AliveScope>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
